// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".broad-file-answer[data-v-65ef0c70]{display:flex;flex-direction:column;align-items:flex-start}.text-answer[data-v-65ef0c70]{word-break:break-word;white-space:pre-wrap}", ""]);
// Exports
module.exports = exports;
